export default {
  breakpoints: {
    xl: '1200px',
    lg: '992px',
    md: '768px',
    sm: '576px',
  },
  EMPTY_BREAKPOINT: '',
  BREAKPOINT_ORDER: ['', 'sm', 'md', 'lg', 'xl'],
};
